import React from 'react'
import Home from './Home'
import Value from './Value'
import FeaturedProduct from './FeaturedProduct'
import Recognized from './Recognized'
import Footer from './Footer'

const Main = () => {
  return (
    <div>
   <Home/>
     <Value/>
     <FeaturedProduct/>
     <Recognized/>
     <Footer/>
    </div>
  )
}

export default Main  
